import { gql } from 'apollo-angular';

export const minimalTableViewFragment = gql`
  fragment MinimalTableViewFragment on TableView {
    id
    name
    order
    isSystem
  }
`;

export const tableViewFragment = gql`
  fragment TableViewFragment on TableView {
    id
    name
    showFilters
    showPinnedFilters
    perPage
    order
    isSystem
    sort {
      column
      direction
    }
    columns {
      name
      isSelected
      width
      order
    }
    queryParameters
    pinnedFilters {
      id
      name
      order
    }
  }
`;

export const tableViewGroupQuery = gql`
  query TableViewGroup($name: String!) {
    tableViewGroup(name: $name) {
      id
      name
      tableViews {
        ...TableViewFragment
      }
      defaultTableView {
        name
      }
    }
  }
  ${tableViewFragment}
`;

export const upsertTableViewGroupMutation = gql`
  mutation UpsertTableViewGroup($input: UpsertTableViewGroupInput!) {
    upsertTableViewGroup(input: $input) {
      tableViews {
        ...MinimalTableViewFragment
      }
    }
  }
  ${minimalTableViewFragment}
`;

export const deleteTableViewMutation = gql`
  mutation DeleteTableView($id: ID!) {
    deleteTableView(id: $id) {
      name
    }
  }
`;

export const setTableViewAsDefaultForGroupMutation = gql`
  mutation SetTableViewAsDefaultForGroup(
    $groupName: String!
    $tableViewName: String
    $tableViewId: ID
    $isSystem: Boolean
  ) {
    setTableViewAsDefaultForGroup(
      groupName: $groupName
      tableViewName: $tableViewName
      tableViewId: $tableViewId
      isSystem: $isSystem
    ) {
      id
      tableViews {
        ...MinimalTableViewFragment
      }
    }
  }
  ${minimalTableViewFragment}
`;

export const unsetDefaultTableViewForGroupMutation = gql`
  mutation UnsetDefaultTableViewForGroup($groupId: ID!) {
    unsetDefaultTableViewForGroup(groupId: $groupId) {
      id
      tableViews {
        ...MinimalTableViewFragment
      }
    }
  }
  ${minimalTableViewFragment}
`;
